import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
import { breakpoint } from 'utils/mediaQueries';
import { textBold } from 'styles';
import Markdown from 'utils/markdownToComponent';

const Title = styled(Markdown)`
  line-height: 2rem;
  font-size: ${props => `${props.theme.typography.h6.fontSize}px`};
  font-family: ${props => `${props.theme.typography.h6.fontFamily}`};
  ${textBold};
  ${breakpoint.down('sm')`
    font-size: ${props => `${props.theme.typography.body1.fontSize}px`}`};
  span {
    font-size: ${props => `${props.theme.typography.h2.fontSize}px`};
  }
`;
const Author = styled(Typography)`
  ${breakpoint.down('sm')`
    font-size: ${props => `${props.theme.typography.subtitle2.fontSize}px`}`}
`;
const ContentGrid = styled(Grid)`
  text-align: left;
  ${breakpoint.down('md')`
  text-align: center`}
`;
const TitleGrid = styled(ContentGrid)`
  ${breakpoint.down('md')`
  text-align: center`}
`;
const GridContent = styled(Grid)`
  padding: 2rem;
  padding-top: 8rem;
  ${breakpoint.down('md')`
  padding: 1rem;`}
`;
const Subtitle = styled(Typography)`
  padding-top: 3rem;
  ${textBold}
  ${breakpoint.down('sm')`
    font-size: ${props => `${props.theme.typography.subtitle2.fontSize}px`}`}
`;
const StyledMarkdown = styled(Markdown)`
  margin: 0;
  font-size: ${props => `${props.theme.typography.body1.fontSize}
px`};
  width: 90%;
  line-height: 1.8rem;
  ${breakpoint.down('md')`
  width:100%;
  font-size: ${props => `${props.theme.typography.body2.fontSize}
px`};`}
  ${breakpoint.down('sm')`
    font-size: ${props => `${props.theme.typography.body2.fontSize}px`}`}
`;
const ExplanationsText = ({ data }) => {
  return (
    <GridContent
      container
      item
      xs={'auto'}
      sm={8}
      md={6}
      lg={6}
      direction="column"
    >
      <TitleGrid>
        <Title variant="h6">{data.subtitle.rawMarkdownBody}</Title>
        <Author variant="body1">{data.subtitle.frontmatter.author}</Author>
      </TitleGrid>
      <ContentGrid>
        <Subtitle variant="body1">{data.content.frontmatter.subTitle}</Subtitle>
        <StyledMarkdown>{data.content.rawMarkdownBody}</StyledMarkdown>
      </ContentGrid>
    </GridContent>
  );
};
export default ExplanationsText;
